import { gql } from "@apollo/client"

const GET_WAITING_LIST_SUMMARY = gql`
  query($event_id: ID!) { 
    reportWaitingListSummary(event_id: $event_id) {
      total
      has_booked
      has_not_booked
      bookable
      no_of_groups
      no_of_guardians
    }
  }
`

export default GET_WAITING_LIST_SUMMARY
